import { render, staticRenderFns } from "./Shortener.vue?vue&type=template&id=663ad3f8&"
import script from "./Shortener.vue?vue&type=script&lang=js&"
export * from "./Shortener.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports